/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboards_List_Empty_HintInputs */



/**
* | output |
* | --- |
* | "Ask the AI assistant in a chat to create a dashboard from this dataset." |
*
* @param {Dashboards_List_Empty_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboards_list_empty_hint = /** @type {((inputs?: Dashboards_List_Empty_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboards_List_Empty_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitten Sie den KI-Assistenten in einem Chat, ein Dashboard aus diesem Datensatz zu erstellen.")
	return /** @type {LocalizedString} */ ("Ask the AI assistant in a chat to create a dashboard from this dataset.")
});